// @ts-nocheck

import { mount, unmount, findIslands } from "./islands.jsx";

let io = null;

// Lazy hydrate when visible
function observe(nodes) {
  if (!("IntersectionObserver" in window)) {
    nodes.forEach(mount);
    return;
  }
  if (!io) {
    io = new IntersectionObserver(
      (entries, obs) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            obs.unobserve(e.target);
            mount(e.target);
          }
        }
      },
      { rootMargin: "200px" },
    );
  }
  nodes.forEach((n) => io.observe(n));
}

// Unmount if nodes are removed
const mo = new MutationObserver((muts) => {
  muts.forEach((m) => {
    m.removedNodes.forEach((n) => {
      if (n instanceof HTMLElement) {
        if (n.matches?.("[data-component]")) unmount(n);
        n.querySelectorAll?.("[data-component]").forEach((el) => unmount(el));
      }
    });
  });
});
mo.observe(document, { childList: true, subtree: true });

// Initial pass
document.addEventListener("DOMContentLoaded", () => {
  observe(findIslands(document));
});

// Optional global hook if you inject HTML later
window.ReactIslands = {
  hydrateAll(scope) {
    observe(findIslands(scope || document));
  },
};
